import * as React from 'react';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import { motion } from 'framer-motion';

import { easeTransition } from '@components/framer';
import Typography from '@components/basics/typography';
import CircleArrowIcon from '@components/basics/icons/circle-arrow';

import NotificationRowCtrl from '../notification-row';
import NotificationItemChange from './item-change';

import TextWrapper from '../text-wrapper';

export interface NotificationChangesCtrlProps {
  className?: string;
  isRead: boolean;
  imgSrc: string;
  imgAlt?: string;
  releaseName: string;
  timestamp: string;
  changes: string;
  id: string;
  clearNotification: (id) => void;
}

export const NotificationChangesCtrl: React.FC<
  NotificationChangesCtrlProps
> = ({
  changes,
  className,
  isRead,
  imgSrc,
  imgAlt,
  releaseName,
  timestamp,
  id,
  clearNotification,
}) => {
  const [isOpen, setOpen] = React.useState(false);

  const container = {
    visible: {
      height: '100%',
      transition: {
        ...easeTransition,
      },
    },
    hidden: {
      height: 0,
    },
  };

  return (
    <>
      <NotificationRowCtrl
        isRead={isRead}
        imgSrc={imgSrc}
        imgAlt={imgAlt}
        timestamp={timestamp}
        isOpen={isOpen}
        hasOpen={true}
        className={className}
        id={id}
        clearNotification={(id) => clearNotification(id)}
        actions={
          <StyledCircleArrowIcon
            size="24px"
            arrowUp={isOpen}
            isWhite
            smallArrow
            onClick={() => setOpen(!isOpen)}
          />
        }
      >
        <TextWrapper
          justifyContent="flex-start"
          alignItems="baseline"
          isRead={isRead}
        >
          <StyledTypography weight="400">
            <Translate id="NOTIFICATION.CHANGES.TEXT" />
            &nbsp;
          </StyledTypography>
          <StyledTypography weight="700">{releaseName}&nbsp;</StyledTypography>
        </TextWrapper>
      </NotificationRowCtrl>
      {isOpen ? (
        <ChangesWrapper
          initial="hidden"
          animate={isOpen ? 'visible' : 'hidden'}
          exit="hidden"
          variants={container}
          isOpen={isOpen}
        >
          <NotificationItemChange text={changes} />
        </ChangesWrapper>
      ) : null}
    </>
  );
};

export default NotificationChangesCtrl;

const ChangesWrapper = styled(motion.div)<{ isOpen: boolean }>`
  background-color: ${({ theme }) => theme.colors.box};
  border-radius: 0 0 10px 10px;
  padding: 20px;
  padding-left: 60px;
  margin-bottom: 8px;
  margin-top: 3px;

  @media ${({ theme }) => theme.device.laptop} {
    padding: 30px;
    padding-left: 80px;
  }
`;

const StyledTypography = styled(Typography)`
  white-space: nowrap;
`;

const StyledCircleArrowIcon = styled(CircleArrowIcon)`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;
